@if (viewModelFF$ | async; as vmFF) {
	@if (vmFF.showTaxBanner || vmFF.showPromptBanner || vmFF.tinVerificationStatus) {
		<div class="banners-wrapper">
			@if (vmFF.showPromptBanner && !isPromptWeb3) {
				<prompts-banner [promptsData]="vmFF.promptsData"></prompts-banner>
			}

			<!-- TODO: handle if status is in_review -->
			@if (vmFF.tinVerificationStatus?.flagOn && !vmFF.tinVerificationStatus?.hasError) {
				<tax-number-identification-banner
					[data]="vmFF.tinVerificationStatus"
					(onCTA)="handleTinVerificationCTA()" />
			}
			@if (vmFF.showTaxBanner && !vmFF.tinVerificationStatus?.flagOn) {
				<taxes-banner
					[isCertificationStep]="vmFF.isSelfCertificationStep"
					[isUpdatingStatus]="vmFF.isUpdateInProgress"></taxes-banner>
			}
			<!-- web3 prompt only to be shown if no other prompt and no tax banner are to be shwon -->
			@if (vmFF.showPromptBanner && !vmFF.showTaxBanner && !isWeb3PromptHidden()) {
				<prompts-banner [promptsData]="vmFF.promptsData"></prompts-banner>
			}
		</div>
	}
	<!-- Carousel should be disabled for UK -->
	<!-- Leaving this as a comment / warning for next sync -->
	<!-- <top-movers></top-movers> -->
	<div class="separator"></div>
}
@if (viewModel$ | async; as vm) {
	<!-- Carousel should be disabled for UK -->
	<!-- Leaving this as a comment / warning for next sync -->
	<!-- <carousel></carousel> -->
	<div class="ribbon-container">
		@if (showKycBanner | async) {
			<kyc-banner></kyc-banner>
		}
		<ng-container *featureVisibility="featureList.STAKING_GLOBAL">
			@if (vm.showStakingBanner) {
				<app-staking-widget></app-staking-widget>
			}
		</ng-container>
	</div>
	<div class="bp-container">
		<custody-account-banner></custody-account-banner>
		@if (isDesktopView()) {
			<div class="widgets">
				<div class="wide">
					<ng-container [ngTemplateOutlet]="verificationAndDeposits"></ng-container>
					@if (vm.showPortfolioWidget) {
						<ng-container
							[ngTemplateOutlet]="portfolioWidget"
							[ngTemplateOutletContext]="{ loading: false }">
						</ng-container>
					}
					@if (showStories$ | async) {
						<bp-stories></bp-stories>
					}
					@if (vm.showActivityWidget) {
						<ng-container
							[ngTemplateOutlet]="activityWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					}
				</div>
				<div class="narrow">
					<!-- Cool off is needed for UK -->
					<ng-container [ngTemplateOutlet]="coolOffWidget" [ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (isMarginTradingEnabled && marginPositions.length) {
						<ng-container
							[ngTemplateOutlet]="marginTradingWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					}
					<ng-container [ngTemplateOutlet]="followingWidget" [ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (vm.showCashPlusWidget) {
						<ng-container
							[ngTemplateOutlet]="cashPlusWidget"
							[ngTemplateOutletContext]="{ loading: false }">
						</ng-container>
					}
					<ng-container
						*featureVisibility="featureList.STAKING_GLOBAL"
						[ngTemplateOutlet]="stakingWidget"
						[ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (vm.showSavingsWidget) {
						<ng-container
							[ngTemplateOutlet]="savingsWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					}
					<!-- BEST is not available in UK -->
					<!-- @if (vm.showBestWidget) {
						<ng-container
							[ngTemplateOutlet]="bestWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					} -->
				</div>
			</div>
		} @else {
			<div class="widgets">
				<div class="wide">
					<ng-container [ngTemplateOutlet]="verificationAndDeposits"></ng-container>
					<!-- Cool off is needed for UK -->
					<ng-container [ngTemplateOutlet]="coolOffWidget" [ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (vm.showPortfolioWidget) {
						<ng-container
							[ngTemplateOutlet]="portfolioWidget"
							[ngTemplateOutletContext]="{
								loading: false
							}"></ng-container>
					}
					@if (showStories$ | async) {
						<bp-stories></bp-stories>
					}
					<ng-container [ngTemplateOutlet]="followingWidget" [ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (vm.showCashPlusWidget) {
						<ng-container
							[ngTemplateOutlet]="cashPlusWidget"
							[ngTemplateOutletContext]="{ loading: false }">
						</ng-container>
					}
					<ng-container
						*featureVisibility="featureList.STAKING_GLOBAL"
						[ngTemplateOutlet]="stakingWidget"
						[ngTemplateOutletContext]="{ loading: false }">
					</ng-container>
					@if (vm.showActivityWidget) {
						<ng-container
							[ngTemplateOutlet]="activityWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					}
					@if (vm.showSavingsWidget) {
						<ng-container
							[ngTemplateOutlet]="savingsWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					}
					<!-- BEST is not available in UK -->
					<!-- @if (vm.showBestWidget) {
						<ng-container
							[ngTemplateOutlet]="bestWidget"
							[ngTemplateOutletContext]="{ loading: false }"></ng-container>
					} -->
				</div>
			</div>
		}
	</div>
}

<!-- Cool off is needed for UK -->
<ng-template #coolOffWidget let-loading="loading">
	@if (!loading) {
		@if (coolOffWidgetModel$ | async; as coolOffWidgetData) {
			@if (!loading && showCoolOffWidget) {
				<cool-off-widget
					(countdownEnd)="onCountDownEndRefetchData($event)"
					class="widget card"
					[data]="coolOffWidgetData">
				</cool-off-widget>
			}
		}
	} @else {
		<bp-content-load-indicator class="widget fb-250 placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #portfolioWidget let-loading="loading">
	@if (!loading) {
		<portfolio-widget class="widget card"></portfolio-widget>
	} @else {
		<bp-content-load-indicator class="widget placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #followingWidget let-loading="loading">
	@if (!loading) {
		<following-widget class="widget card savings"></following-widget>
	} @else {
		<bp-content-load-indicator class="widget fb-250 placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #stakingWidget let-loading="loading">
	@if (!loading) {
		<staking-widget class="widget card savings"></staking-widget>
	} @else {
		<bp-content-load-indicator class="widget fb-250 placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #savingsWidget let-loading="loading">
	@if (!loading) {
		<savings-widget class="widget card savings"></savings-widget>
	} @else {
		<bp-content-load-indicator class="widget fb-250 placeholder"></bp-content-load-indicator>
	}
</ng-template>
<!-- BEST is not available in UK -->
<!-- @let phase = (mergePhase$ | async)?.phase;
<ng-template #bestWidget let-loading="loading">
	@if (!loading) {
		@if (phase === web3MergePhase.None || phase === web3MergePhase.Announced) {
			@let bestWidgetModel = bestWidgetModel$ | async;
			<best-widget-weekly class="widget card" [bestWidgetModel]="bestWidgetModel"></best-widget-weekly>
		}
	} @else {
		<bp-content-load-indicator class="widget placeholder"></bp-content-load-indicator>
	}
</ng-template> -->

<ng-template #activityWidget let-loading="loading">
	@if (!loading) {
		<activity-widget class="widget card"></activity-widget>
	} @else {
		<bp-content-load-indicator class="widget placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #verificationAndDeposits>
	<verification-banner></verification-banner>
	<deposits-banner></deposits-banner>
</ng-template>

<ng-template #cashPlusWidget let-loading="loading">
	<cashplus-widget class="widget card"></cashplus-widget>
	@if (loading) {
		<bp-content-load-indicator class="widget placeholder"></bp-content-load-indicator>
	}
</ng-template>

<ng-template #marginTradingWidget let-loading="loading">
	@if (!loading) {
		<div class="widget card margin-positions">
			<div class="flex justify-between">
				<h4>{{ "positions_at_risk" | translate }}</h4>
				<span class="link-style" (click)="seeAllPositions()">{{
					"dashboard_watchlist_see_all" | translate
				}}</span>
			</div>
			@for (marginPosition of marginPositions; track marginPosition.id) {
				<mt-summary-card [marginPosition]="marginPosition" [isHome]="true"></mt-summary-card>
			}
		</div>
	} @else {
		<bp-content-load-indicator class="widget placeholder"></bp-content-load-indicator>
	}
</ng-template>

<router-outlet></router-outlet>
